module.exports = __webpack_public_path__ + "img/map.5b7fcc35.png";